import $ from 'jquery';
import 'slick-carousel';

document.querySelectorAll('.slider4d__container').forEach((highlights) => {
	$(highlights).slick({
		dots: true,
		fade: true,
		arrows: true,
		rows: 0,
		appendDots: '.slider4d__navigation'
	});

	document.querySelectorAll('.slider4d__next').forEach((arrow) => {
		arrow.addEventListener('click', (e) => {
			$(highlights).slick('slickNext');
		});
	});
})


